export default "__VITE_ASSET__2fcbac19__"